import produce from 'immer';

import { shopProductsSortOptions } from '../shared/constants/shopProductsSortOptions';
import { subscriptionStatuses } from '../shared/constants/shopSubscriptionStatuses';

import {
  SET_SHOP_FILTERS,
  RESET_SHOP_FILTERS,
  SET_SHOP_SORTING,
  FETCH_SHOP_PRODUCTS,
  FETCH_SHOP_PRODUCTS_SUCCESS,
  FETCH_SHOP_PRODUCTS_ERROR,
  CHANGE_SHOP_PRODUCTS_FAVORITE_STATUS_SUCCESS,
  CHANGE_SHOP_PRODUCTS_FAVORITE_STATUS_ERROR,
  ADD_SHOP_PRODUCTS_TO_BASKET_SUCCESS,
  REMOVE_SHOP_PRODUCTS_FROM_BASKET_SUCCESS,
  FETCH_SHOP_HISTORY,
  FETCH_SHOP_HISTORY_SUCCESS,
  FETCH_SHOP_HISTORY_ERROR,
  SET_SHOP_ACIVE_VIEW,
  FETCH_SHOP_PRODUCT_PROPERTIES_SUCCESS,
  FETCH_SHOP_PRODUCT_PROPERTIES_ERROR,
  FETCH_SHOP_PRODUCT_PROPERTIES,
  START_SHOP_PRODUCT_FREE_TRIAL_ERROR,
  START_SHOP_PRODUCT_FREE_TRIAL_SUCCESS,
  START_SHOP_PRODUCT_FREE_SUBSCRIPTION_ERROR,
  START_SHOP_PRODUCT_FREE_SUBSCRIPTION_SUCCESS,
} from './shopActions';

const initialState = {
  filters: {
    regions: '',
    segments: '',
    categories: '',
  },
  sortBy: shopProductsSortOptions.name,
  products: {
    isPending: false,
    data: [],
  },
  history: {
    isPending: false,
    purchases: [],
    favorites: [],
    basket: {
      data: [],
      lastUpdate: null,
    },
  },
  activeView: null,
  properties: {
    isPending: true,
    data: {
      categories: [],
      regions: [],
      productLines: [],
      segments: [],
      sources: [],
      industries: [],
      tiers: [],
      tools: [],
      durations: [],
      cancelPeriods: [],
      units: [],
    },
  },
};

export function shop(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case SET_SHOP_FILTERS:
      return { ...state, filters: payload.filters };
    case RESET_SHOP_FILTERS:
      return { ...state, filters: initialState.filters };
    case SET_SHOP_SORTING:
      return { ...state, sortBy: payload.sortBy };
    case FETCH_SHOP_PRODUCTS:
      return { ...state, products: { ...state.products, isPending: true } };
    case FETCH_SHOP_PRODUCTS_SUCCESS:
      return { ...state, products: { data: payload.products.data, isPending: false } };
    case FETCH_SHOP_PRODUCTS_ERROR:
      return { ...state, products: { data: [], isPending: false } };
    case CHANGE_SHOP_PRODUCTS_FAVORITE_STATUS_SUCCESS: {
      return produce(state, draftState => {
        const { ids: productIds, isFavorite } = payload;

        // eslint-disable-next-line no-param-reassign
        draftState.history.favorites = isFavorite
          ? [...state.history.favorites, ...productIds]
          : state.history.favorites.filter(id => !productIds.includes(id));

        return draftState;
      });
    }
    case FETCH_SHOP_HISTORY:
      return { ...state, history: { ...state.history, isPending: true } };
    case FETCH_SHOP_HISTORY_SUCCESS:
      return { ...state, history: { ...payload.history, isPending: false } };
    case FETCH_SHOP_HISTORY_ERROR:
      return { ...state, history: { ...state.history, isPending: true } };
    case ADD_SHOP_PRODUCTS_TO_BASKET_SUCCESS:
      return produce(state, draftState => {
        const basketItems = state.history.basket.data;
        // eslint-disable-next-line no-param-reassign
        draftState.history.basket = {
          data: [...basketItems, ...payload.ids.filter(id => !basketItems.includes(id))],
          lastUpdate: new Date(),
        };

        return draftState;
      });
    case REMOVE_SHOP_PRODUCTS_FROM_BASKET_SUCCESS:
      return produce(state, draftState => {
        // eslint-disable-next-line no-param-reassign
        draftState.history.basket = {
          data: state.history.basket.data.filter(id => !payload.ids.includes(id)),
          lastUpdate: new Date(),
        };

        return draftState;
      });
    case SET_SHOP_ACIVE_VIEW:
      return { ...state, activeView: payload.view };
    case FETCH_SHOP_PRODUCT_PROPERTIES:
      return { ...state, properties: { ...state.properties, isPending: true } };
    case FETCH_SHOP_PRODUCT_PROPERTIES_SUCCESS:
      return { ...state, properties: { data: payload.properties, isPending: false } };
    case FETCH_SHOP_PRODUCT_PROPERTIES_ERROR:
      return { ...state, properties: { data: [], isPending: false } };
    case START_SHOP_PRODUCT_FREE_SUBSCRIPTION_SUCCESS: {
      return produce(state, draftState => {
        const { id } = payload;

        // eslint-disable-next-line no-param-reassign
        draftState.products.data = state.products.data.map(product =>
          product.id === id
            ? {
                ...product,
                purchased: true,
                status: subscriptionStatuses.ACTIVE,
              }
            : product,
        );

        return draftState;
      });
    }
    case START_SHOP_PRODUCT_FREE_TRIAL_SUCCESS: {
      return produce(state, draftState => {
        const { id } = payload;

        // eslint-disable-next-line no-param-reassign
        draftState.products.data = state.products.data.map(product =>
          product.id === id
            ? {
                ...product,
                purchased: true,
                status: subscriptionStatuses.ACTIVE_TRIAL,
              }
            : product,
        );

        return draftState;
      });
    }
    case CHANGE_SHOP_PRODUCTS_FAVORITE_STATUS_ERROR:
    case START_SHOP_PRODUCT_FREE_SUBSCRIPTION_ERROR:
    case START_SHOP_PRODUCT_FREE_TRIAL_ERROR:
    default:
      return state;
  }
}
